// SW: "n / total" counter on product galleries. The active slide is tracked with an IntersectionObserver on the
// carousel (no layout reads on scroll). Each gallery is set up once; a variant change or section reload only
// recounts the slides when the visible set changed. The counter is visual only (aria-hidden): every slide already
// has its own "item n of count" label.
(function () {
  'use strict';

  function setup(gallery) {
    var carousel = gallery.querySelector('.product-gallery__carousel');
    var imageList = gallery.querySelector('.product-gallery__image-list');
    if (!carousel || !imageList) return;

    var state = gallery._swCounter;
    var slides = Array.from(gallery.querySelectorAll('.product-gallery__media:not([hidden])'));

    if (state) {
      if (state.carousel === carousel && state.slides.length === slides.length && state.slides.every(function (s, i) { return s === slides[i]; })) return;
      state.observer.disconnect();
      state.counter.remove();
      gallery._swCounter = null;
    }

    // Remove any server or earlier counter to avoid duplicates
    var existing = imageList.querySelector('.sw-gallery-counter');
    if (existing) existing.remove();

    if (slides.length < 2 || !('IntersectionObserver' in window)) return;

    imageList.style.position = 'relative';

    var counter = document.createElement('div');
    counter.className = 'sw-gallery-counter';
    counter.setAttribute('aria-hidden', 'true');
    imageList.appendChild(counter);

    var ratios = slides.map(function () { return 0; });
    var current = -1;

    function render(idx) {
      if (idx === current) return;
      current = idx;
      counter.textContent = (idx + 1) + ' / ' + slides.length;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = slides.indexOf(entry.target);
        if (i > -1) ratios[i] = entry.intersectionRatio;
      });
      var best = 0;
      for (var i = 1; i < ratios.length; i++) if (ratios[i] > ratios[best]) best = i;
      render(best);
    }, { root: carousel, threshold: [0, 0.25, 0.5, 0.75, 1] });

    slides.forEach(function (slide) { observer.observe(slide); });
    var initial = slides.findIndex(function (s) { return s.classList.contains('is-initial'); });
    render(initial > -1 ? initial : 0);

    gallery._swCounter = { carousel: carousel, slides: slides, observer: observer, counter: counter };
  }

  function setupAll(root) {
    (root || document).querySelectorAll('product-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(); });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (e) { setupAll(e.target); });
  // The theme filters the slides right after a variant change; recount on the next frame
  document.addEventListener('variant:change', function () {
    requestAnimationFrame(function () { setupAll(); });
  });
})();
